import React, { useState, useRef, useEffect } from "react";
import styles from './ConstruyeTuCamino.module.css';
import "./ConstruyeTuCamino.css";
import { construyeTuCaminoData } from "../../json/construyeTuCaminoData";
import { construyeTuCaminoCards } from "../../json/construyeTuCaminoCards";
import { construyeTuCaminoResultados } from "../../json/construyeTuCaminoResultados";


const ConstruyeTuCamino = () => {
    const [curp, setCurp] = useState("");
    const [modalMessage, setModalMessage] = useState("");
    const [reportData, setReportData] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === "Escape" && isModalOpen) {
                setIsModalOpen(false);
                setReportData(null);
            }
        };
        window.addEventListener("keydown", handleEscKey);
        return () => {
            window.removeEventListener("keydown", handleEscKey);
        };
        }, [isModalOpen]
    )

    const handleInputChange = (e) => {
        const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 18);
        setCurp(value);
    };

    const handleSearch = () => {
        if (!curp) {
            setModalMessage("Por favor, ingrese su CURP para realizar una búsqueda");
            setIsModalOpen(true);
            return;
        }
        if (curp.length < 18) {
            setModalMessage("CURP incompleta, por favor, valide su información");
            setIsModalOpen(true);
            return;
        }
        const result = construyeTuCaminoData.find((item) => item.curp === curp);
        if (!result) {
            setModalMessage("No encontramos coincidencias para el CURP especificado");
        } else {
            setReportData(result);
        }
        setIsModalOpen(true);
    };

    const handleClear = () => {
        if (curp) {
            setCurp("");
            inputRef.current.focus();
        }
    };

    const formatoMoneda = (valor) => {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
        }).format(valor);
    };

    const totalInversion = construyeTuCaminoResultados.reduce((acc, obra) => acc + Number(obra.inversion), 0);

    return (
        <div className="content container transparencia-container container-mh">
            <div className="row">
                <div className="col_12">
                    <div className="transparencia_title">
                        <h1>Construye Tu Camino 2026</h1>
                    </div>
                </div>
            </div>

            <section className="container-ctc-all">
                <div className="image-ctc">
                </div>
                <div className="card-container">
                    {construyeTuCaminoCards.map((card, index) => (
                        <a className="card-ctc" key={index} href={card.urlCtc}>
                            <div className="icon-ctc">
                                <i className={card.icoName}></i>
                            </div>
                            <div className="title-ctc">{card.urlName}</div>
                        </a>
                    ))}
                </div>
            </section>

            {/*Tabla Resultados*/}

            {/*<section>*/}
            {/*    <div>*/}
            {/*        <h2 className={styles['table-title']}>Cartera de Proyectos Viables</h2>*/}
            {/*        <table className={`table table-striped ${styles['table-ctc']}`}>*/}
            {/*            <thead>*/}
            {/*                <tr>*/}
            {/*                    <th>NO.</th>*/}
            {/*                    <th>NOMBRE DEL PROYECTO</th>*/}
            {/*                    <th>MUNICIPIO</th>*/}
            {/*                    <th>LOCALIDAD</th>*/}
            {/*                    <th>INVERSIÓN</th>*/}
            {/*                </tr>*/}
            {/*            </thead>*/}
            {/*            <tbody>*/}
            {/*                {construyeTuCaminoResultados.map((obra) => (*/}
            {/*                    <tr key={obra.num}>*/}
            {/*                        <td className={styles['cell-number']}>{obra.num}</td>*/}
            {/*                        <td>{obra.proyecto}</td>*/}
            {/*                        <td>{obra.municipio}</td>*/}
            {/*                        <td>{obra.localidad}</td>*/}
            {/*                        <td>{formatoMoneda(Number(obra.inversion))}</td>*/}
            {/*                    </tr>*/}
            {/*                ))}*/}
            {/*            </tbody>*/}
            {/*            <tfoot>*/}
            {/*                <tr>*/}
            {/*                    <td colSpan={3}></td>*/}
            {/*                    <td className={styles.summation}>Total:</td>*/}
            {/*                    <td>{formatoMoneda(totalInversion)}</td>*/}
            {/*                </tr>*/}
            {/*            </tfoot>*/}
            {/*        </table>*/}
            {/*    </div>*/}
            {/*</section>*/}

            {/*Buscador*/}

            {/*<section className="seeker-container">*/}
            {/*    <label className="seeker-header">Ingresa tu CURP <em>(Clave Única de Registro de Población)</em> para consultar el estatus de tú camino</label>*/}
            {/*    <input*/}
            {/*        ref={inputRef}*/}
            {/*        className="data"*/}
            {/*        type="text"*/}
            {/*        value={curp}*/}
            {/*        onChange={handleInputChange}*/}
            {/*        onKeyDown={(e) => {*/}
            {/*            if (e.key === "Enter") {*/}
            {/*                handleSearch();*/}
            {/*            }*/}
            {/*            }}*/}
            {/*        placeholder="Ingresa aquí tu CURP"*/}
            {/*    />*/}
            {/*    <a className="consult-curp" href="https://www.gob.mx/curp/" target="_blank">Consulta aquí tu CURP</a>*/}
            {/*    <nav className="buttons-container">*/}
            {/*        <button className="button-ctc" onClick={handleSearch}>*/}
            {/*            <i className="button-icon-container icon-magnifying-glass1"></i>*/}
            {/*            <p className="button-title-ctc">Buscar</p>*/}
            {/*        </button>*/}
            {/*        <button className="button-ctc" onClick={handleClear}>*/}
            {/*            <i className="button-icon-container icon-broom"></i>*/}
            {/*            <p className="button-title-ctc">Borrar</p>*/}
            {/*        </button>*/}
            {/*    </nav>*/}
            {/*</section>*/}
            {/*    {isModalOpen && (*/}
            {/*        <div className="modal">*/}
            {/*            <div className="modal-content">*/}
            {/*                {reportData ? (*/}
            {/*                    <div className="report-container">*/}
            {/*                        <label className="report-curp">{reportData.curp}</label>*/}
            {/*                        <hr className="line-curp" />*/}
            {/*                        <div className="report-data">*/}
            {/*                            <p className="data-title">Nombre del solicitante</p>*/}
            {/*                            <p className="data-result">{reportData.solicitante}</p>*/}
            {/*                        </div>*/}
            {/*                        <div className="report-data">*/}
            {/*                            <p className="data-title">Nombre del camino</p>*/}
            {/*                            <p className="data-result">{reportData.camino}</p>*/}
            {/*                        </div>*/}
            {/*                        <div className="report-data">*/}
            {/*                            <p className="data-title">Localidad</p>*/}
            {/*                            <p className="data-result">{reportData.localidad}</p>*/}
            {/*                        </div>*/}
            {/*                        <div className="report-data">*/}
            {/*                            <p className="data-title">Municipio</p>*/}
            {/*                            <p className="data-result">{reportData.municipio}</p>*/}
            {/*                        </div>*/}
            {/*                        <div className="report-data">*/}
            {/*                            <p className="data-title">Estatus de solicitud</p>*/}
            {/*                            <p className="data-result">{reportData.estatus}</p>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                ) : (*/}
            {/*                    <p>{modalMessage}</p>*/}
            {/*                )}*/}
            {/*                <button className="button-modal-close" onClick={() => { setIsModalOpen(false); setReportData(null); inputRef.current.focus(); }}>*/}
            {/*                    <i className="icon-cancel"></i>*/}
            {/*                </button>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    )}*/}
        </div>
    );
};

export default ConstruyeTuCamino;
